import { getLocales } from '@src/i18n/locale.util'

// these match keys in dictionary['geo-redirection-modal']
const countryCodesSet = new Set(getLocales().map((l) => l.countryCode))
export const dropdownOptions = [...countryCodesSet]
